import "lib/@hooks/useEvent"
import { useReducer } from "react"
import { useScheduleEditorIds } from "./use-schedule-editor-ids"
import { DraftReloaded, DraftStructureChanged } from "../schedule-editor-event-definitions.mjs"

/**
 * Bumps when the in-memory draft is mutated in place (recommendation apply, task add/delete, etc.).
 * Use as a useMemo dependency so virtualized recommendation rows rebuild applied/ready state.
 *
 * @returns {number}
 */
export function useScheduleEditorDraftStructureVersion() {
    const { draftId } = useScheduleEditorIds()
    const [version, bumpVersion] = useReducer(incrementVersion, 0)

    DraftStructureChanged(draftId).useEvent(bumpVersion)
    DraftReloaded(draftId).useEvent(bumpVersion)

    return version
}

function incrementVersion(current) {
    return current + 1
}
